<template>
  <div>
    <section
      class="compare-bottom-bar sticky-banner w-100"
      v-if="!open && getCompareProducts.length > 1"
    >
      <div class="d-flex">
        <div class="btn left-tick">
          <span class="count">{{ getCompareProducts.length }}</span>
          <span
            class="tick-icon png-icon png-icon-icons-glyph--ko-check"
          ></span>
        </div>
        <div class="d-flex right-side w-100 justify-content-between">
          <div class="text-uppercase compare-items-count">
            <b>{{ $resourceString['product.Search.Label.Compare'] }}</b> <br />
            <span class="text-muted">{{ $resourceString['product.Search.Label.Items'] }}</span>
          </div>
          <div class="d-flex">
            <button
              class="btn border border-dark justify-content-start mr-3 hide-mobile-tablet"
              :class="[sliceStart == 0 ? 'disabled-prev-next-btn' : '']"
              @click="prev"
            >
              <span
                :class="[
                  sliceStart == 0
                    ? 'png-icon png-icon-icons-glyph--g-chevron-left'
                    : 'png-icon png-icon-icons-glyph--k-chevron-left'
                ]"
              ></span>
            </button>
            <div
              class="d-flex hide-mobile-tablet"
              v-for="(item, index) in getCompareProducts.slice(
                sliceStart,
                sliceEnd
              )"
              :key="item.styleNumber"
            >
              <div class="mr-3">
                <img
                  class="tiles-list"
                  @error="handleImageError"
                  :alt="item.colors[0].colorNumber"
                  :src="
                    viewMode === 'swatch'
                      ? $helpers.getColorThumbnailImageUrl(
                          item.sellingStyleNumber,
                          item.selectedColor.colorNumber?item.selectedColor.colorNumber:item.colors[0].colorNumber
                        )
                      : $helpers.getInteractiveRoomSceneImageUrl(
                          item.sellingStyleNumber,
                          item.selectedColor.colorNumber?item.selectedColor.colorNumber:item.colors[0].colorNumber,
                          item.roomsceneIds && item.roomsceneIds[Math.floor(Math.random() * item.roomsceneIds.length)],
                          item.recommendedInstallationMethodsInfo && item.recommendedInstallationMethodsInfo[0] && item.recommendedInstallationMethodsInfo[0].name ? item.recommendedInstallationMethodsInfo[0].name : '1',
                          500
                        )
                  "
                />
                <span
                  class="img-close"
                  @click="removeCompareProduct(item.sellingStyleNumber)"
                  >X</span
                >
              </div>
            </div>
            <button
              class="btn border border-dark justify-content-start mr-5 hide-mobile-tablet"
              :class="[
                getCompareProducts.length <= sliceEnd
                  ? 'disabled-prev-next-btn'
                  : ''
              ]"
              @click="next"
            >
              <span
                :class="[
                  getCompareProducts.length <= sliceEnd
                    ? 'png-icon png-icon-icons-glyph--g-chevron-right'
                    : 'png-icon png-icon-icons-glyph--k-chevron-right'
                ]"
              ></span>
            </button>
            <button class="btn btn-primary compare-button" @click="openModal">
              {{ $resourceString['product.Search.Label.Compare'] }}
              <span
                class="png-icon png-icon-icons-glyph--ko-arrow-next ml-3"
              ></span>
            </button>
          </div>
          <div class="d-flex hide-mobile-tablet">
            <button
              class="btn btn-white border border-dark justify-content-start remove-all-button"
              @click="removeAllCompareProduct"
            >
              <span class="png-icon png-icon-icons-glyph--k-close mr-3"></span>
              {{ $resourceString['common.removeAll'] }}
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { globalIcons } from "../../../constants/global";
export default {
  data() {
    return {
      sliceStart: 0,
      sliceEnd: 4,
      defaultImage:globalIcons.defaultImage
    };
  },
  computed: {
    ...mapGetters({
      open: "compareModal/open",
      getCompareProducts: "productDetail/getCompareProducts",
      viewMode: "filters/viewMode",
      items: "productDisplay/items",

    })
  },
  mounted() {
    this.initialLoadCompareProducts();
  },
  methods: {
    ...mapActions({
      setCompareProduct: "productDetail/setCompareProduct",
      removeCompareProducts: "productDetail/removeCompareProducts",
      removeAllCompareProducts: "productDetail/removeAllCompareProducts",
      initialLoadCompareProducts: "productDetail/initialLoadCompareProducts",
      showCompareContent: "compareModal/showCompareContent"
    }),
    handleImageError(event) {
      event.target.src = this.defaultImage;
    },
    openModal: function() {
      this.$store.dispatch("compareModal/open");
      this.showCompareContent(true);
    },
    removeCompareProduct: function(styleNumber) {
      this.removeCompareProducts(styleNumber);
    },
    removeAllCompareProduct: function() {
      this.removeAllCompareProducts();
    },
    next: function() {
      if (this.sliceEnd < this.getCompareProducts.length) {
        this.sliceStart = this.sliceStart + 1;
        this.sliceEnd = this.sliceEnd + 1;
      }
    },
    prev: function() {
      if (this.sliceStart > 0) {
        this.sliceStart = this.sliceStart - 1;
        this.sliceEnd = this.sliceEnd - 1;
      }
    },
    getRoomSceneId(colorNumber){
      let rngRoom;
      if(this.items.length > 0){
      for (let index = 0; index < this.items.length; index++) {
        let element = this.items[index];
        for (let colorElem = 0; colorElem < element.colors.length; colorElem++) {
          let ColorResult = element.colors[colorElem];
          if(ColorResult.colorNumber == colorNumber ){
            rngRoom = Math.floor(Math.random() * element.roomsceneIds.length)
            return element.roomsceneIds[rngRoom]
          }

        }
      }
    }
    },
  }
};
</script>
